import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-print-footer',
  templateUrl: './print-footer.component.html',
  styleUrl: './print-footer.component.scss'
})
export class PrintFooterComponent {

  userName: string = '';
  currentDate: string = '';
  datePart: any = '';
  timePart: any = '';

  constructor(
    private datePipe: DatePipe,
    private authService: AuthService,

  ) {
  }

  ngOnInit(): void {
    this.userName = this.authService.authUser.UserName;
    // console.log("authUser",this.authService.authUser);
    
    const now = new Date();
    this.datePart = this.datePipe.transform(now, 'dd/MM/yyyy');
    this.timePart = this.datePipe.transform(now, 'shortTime');

    this.currentDate = this.datePart + ' ' + this.timePart;
  }

}
